import {
  Button,
  Flex,
  Heading,
  Link,
  OUTLINE,
  SMALL,
  Text,
  VStack,
} from '@primerai/thread';
import { useSelector, useDispatch } from 'react-redux';
import { Link as RouterLink } from 'wouter';
import { TEXT_SIZE, HEADING_SIZE } from '~/constants';
import { LOGIN } from '~/routes/paths';
import { Actions } from '~/store/password/actions';
import { getForgotPasswordMessage } from '~/store/password/selectors';

const DEFAULT_MESSAGE =
  'Please check your email for a link to reset your password.';

// TODO: figure out why a max width is needed here.  it should flow into the main layout
const LinkWasSent = () => {
  const message = useSelector(getForgotPasswordMessage);
  const dispatch = useDispatch();
  const onClick = () => dispatch(Actions.FORGOT_PASSWORD_RESET());

  return (
    <VStack maxWidth="500px">
      <Heading mb="$2" size={HEADING_SIZE.LARGE}>
        Password reset request sent
      </Heading>
      <Text size={TEXT_SIZE.DEFAULT}>{message ?? DEFAULT_MESSAGE}</Text>
      <Flex alignItems="center" justifyContent="space-between" mt="$9">
        <Link as={RouterLink} to={LOGIN}>
          Sign in
        </Link>
        <Button appearance={OUTLINE} onClick={onClick} size={SMALL}>
          Request another reset link
        </Button>
      </Flex>
    </VStack>
  );
};

export default LinkWasSent;
